import type {
  FeatureServiceBinder,
  FeatureServiceProviderDefinition,
  SharedFeatureService,
} from '@feature-hub/core';
import type {
  SelectedVehicleListenerV1,
  SelectedVehicleServiceV1,
  SelectedVehicleV1,
} from './v1.js';

export type {
  SelectedVehicleServiceV1,
  SelectedVehicleV1,
  SelectedVehicleListenerV1,
} from './v1.js';

export * from './integrator-utils/get-pn18-from-url.js';
export * from './integrator-utils/remove-preselection-from-search-params.js';
export * from './integrator-utils/storage.js';

export interface SharedSelectedVehicleService extends SharedFeatureService {
  readonly '1.0.0': FeatureServiceBinder<SelectedVehicleServiceV1>;
}

export interface SelectedVehicleServiceOptions {
  readonly masterPn18?: string;
  readonly marketId?: string;
}

export function defineSelectedVehicleService(
  options: SelectedVehicleServiceOptions,
): FeatureServiceProviderDefinition<SharedSelectedVehicleService> {
  const {marketId, masterPn18} = options;

  return {
    id: `selected-vehicle-service`,

    create: () => {
      const listeners = new Set<SelectedVehicleListenerV1>();

      let selectedVehicle: SelectedVehicleV1 | undefined;

      return {
        '1.0.0': () => {
          const defaultPN18 =
            marketId === `gb`
              ? `HX1ETD3B62EU010418` // RHD
              : `HX1ETD3A61EU010417`; // LHD;

          return {
            featureService: {
              masterPn18: masterPn18 ?? defaultPN18,

              getSelectedVehicle: () => selectedVehicle,

              setSelectedVehicle: (vehicle) => {
                selectedVehicle = vehicle;

                for (const listener of listeners) {
                  listener(selectedVehicle);
                }
              },

              subscribe: (listener) => {
                listeners.add(listener);

                return () => listeners.delete(listener);
              },
            },
          };
        },
      };
    },
  };
}
